const GREEN_BUCKETS = ["Approval on File", "Approved", "Auth Not Required"];
const YELLOW_BUCKETS = [
  "Case on File",
  "Non-ePA",
  "Not Correct Processor",
  "PA Resolved",
];
const RED_BUCKETS = [
  "Denial on File",
  "Denied",
  "Drug Not Covered",
  "Drug Not Covered - Plan",
  "Drug Not Covered - Pharmacy",
  "Drug Not Covered - Medicare",
];
const GRAY_BUCKETS = ["Other Platforms", "NA Outcome"];

export const getBucketColorClasses = (bucket: string): string => {
  if (GREEN_BUCKETS.includes(bucket))
    return "bg-primaryGreen-11 text-primaryGreen-3";
  if (YELLOW_BUCKETS.includes(bucket)) return "bg-yellow-100 text-yellow-600";
  if (RED_BUCKETS.includes(bucket))
    return "bg-tertiaryRed-11 text-tertiaryRed-3";
  if (GRAY_BUCKETS.includes(bucket))
    return "bg-primaryGray-16 text-primaryGray-3";
  return "bg-primaryGray-16 text-primaryGray-3";
};
